module.exports = __webpack_public_path__ + "img/kalpana.e12099dd.png";